(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	Voonto.getInstance().define(['module'], function (module) {
	    return {
	        wakeUp: function wakeUp($elm) {
	            Logger.info('wake up module ' + module.id);
	
	            var app = Voonto.getInstance();
	
	            var medio = $elm.data('edition');
	            var metric_call = $elm.data('metric');
	
	            var urlMetrics = app.lookup('vocento.config.nibara').metricsUrl;
	            if (urlMetrics === undefined) {
	                throw 'metricsUrl path in config is empty';
	            }
	
	            if (metric_call !== '') {
	                urlMetrics += '?' + metric_call;
	                if (medio === 'sevilla') {
	                    urlMetrics += '&edition=sevilla';
	                } else if (medio === 'abc') {
	                    urlMetrics += '&edition=madrid';
	                }
	                if (urlMetrics.match(/pre.metrics|des.metrics/g)) {
	                    urlMetrics += '&site=metrics.abc.es';
	                }
	
	                //Voonto.$.get(urlMetrics);
	                /*try{
	                    Voonto.$.ajax({
	                        url: urlMetrics+'&callback=?',
	                        dataType: "jsonp",
	                        jsonpCallback: function (data) {
	                            Logger.info('[Metrics ColC] success');
	                        },
	                        error: function(xhr, status, error) {
	                            Logger.info('[Metrics ColC] error. ' + xhr.status + ' - error: ' + error);
	                        }
	                    });
	                } catch (err) {
	                    Logger.info('[Metrics ColC] error ');
	                    Logger.info(err);
	                }*/
	                Voonto.$.ajax({
	                    url: urlMetrics,
	                    dataType: "jsonp"
	                });
	            }
	        }
	    };
	});

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// metrics-colc-module.js